export const completeGroupedOptions = ({ groupedOptions = [], topSelectedOptions = [] }) => {
  const result = [];

  if (topSelectedOptions.length) {
    result.push({ label: 'questionnaire.option_category.top_selected', options: topSelectedOptions });
  }

  result.push(...groupedOptions);
  return result;
};
